import '@babel/polyfill';

import Vue from 'vue';
import './plugins/prototypes';
import './plugins/vuetify';
import './plugins/charts';
//import './plugins/scrollto';
import filters from "./common/filters";
import store from './store'

import App from './App.vue'

Vue.config.productionTip = false

Vue.filter('L', filters.L);
Vue.filter('D', filters.D);
Vue.filter('DT', filters.DT);
Vue.filter('S', filters.S);
new Vue({
  store,
  render: h => h(App)
}).$mount('#app')
